/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminReviewStatsOverviewResponse } from '../models';
// @ts-ignore
import type { AdminReviewStatsReviewsResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
/**
 * ReviewStatsApiApi - axios parameter creator
 */
export const ReviewStatsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Reviews per surface for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewStatsApiGetAdminReviewStatsOverview: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/review-statistics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Every review, rating and written feedback from every surface, newest first.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {boolean} [hasText] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum} [ratingBand] 
         * @param {string | null} [search] 
         * @param {ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum} [sortOrder] 
         * @param {ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum} [source] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewStatsApiGetAdminReviewStatsReviews: async (endDate?: string | null, excludeInternal?: boolean, hasText?: boolean, page?: number, pageSize?: number, ratingBand?: ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum, search?: string | null, sortOrder?: ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum, source?: ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/review-statistics/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (hasText !== undefined) {
                localVarQueryParameter['has_text'] = hasText;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ratingBand !== undefined) {
                localVarQueryParameter['rating_band'] = ratingBand;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReviewStatsApiApi - functional programming interface
 */
export const ReviewStatsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReviewStatsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Reviews per surface for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewStatsApiGetAdminReviewStatsOverview(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminReviewStatsOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewStatsApiGetAdminReviewStatsOverview(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewStatsApiApi.reviewStatsApiGetAdminReviewStatsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Every review, rating and written feedback from every surface, newest first.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {boolean} [hasText] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum} [ratingBand] 
         * @param {string | null} [search] 
         * @param {ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum} [sortOrder] 
         * @param {ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum} [source] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewStatsApiGetAdminReviewStatsReviews(endDate?: string | null, excludeInternal?: boolean, hasText?: boolean, page?: number, pageSize?: number, ratingBand?: ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum, search?: string | null, sortOrder?: ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum, source?: ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminReviewStatsReviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewStatsApiGetAdminReviewStatsReviews(endDate, excludeInternal, hasText, page, pageSize, ratingBand, search, sortOrder, source, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewStatsApiApi.reviewStatsApiGetAdminReviewStatsReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReviewStatsApiApi - factory interface
 */
export const ReviewStatsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReviewStatsApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Reviews per surface for a window, against the window before it.
         * @param {ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewStatsApiGetAdminReviewStatsOverview(requestParameters: ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminReviewStatsOverviewResponse> {
            return localVarFp.reviewStatsApiGetAdminReviewStatsOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Every review, rating and written feedback from every surface, newest first.
         * @param {ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewStatsApiGetAdminReviewStatsReviews(requestParameters: ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsReviewsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminReviewStatsReviewsResponse> {
            return localVarFp.reviewStatsApiGetAdminReviewStatsReviews(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.hasText, requestParameters.page, requestParameters.pageSize, requestParameters.ratingBand, requestParameters.search, requestParameters.sortOrder, requestParameters.source, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reviewStatsApiGetAdminReviewStatsOverview operation in ReviewStatsApiApi.
 */
export interface ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsOverviewRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for reviewStatsApiGetAdminReviewStatsReviews operation in ReviewStatsApiApi.
 */
export interface ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsReviewsRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly hasText?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly ratingBand?: ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum

    readonly search?: string | null

    readonly sortOrder?: ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum

    readonly source?: ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum

    readonly startDate?: string | null
}

/**
 * ReviewStatsApiApi - object-oriented interface
 */
export class ReviewStatsApiApi extends BaseAPI {
    /**
     * 
     * @summary Reviews per surface for a window, against the window before it.
     * @param {ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewStatsApiGetAdminReviewStatsOverview(requestParameters: ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return ReviewStatsApiApiFp(this.configuration).reviewStatsApiGetAdminReviewStatsOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Every review, rating and written feedback from every surface, newest first.
     * @param {ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewStatsApiGetAdminReviewStatsReviews(requestParameters: ReviewStatsApiApiReviewStatsApiGetAdminReviewStatsReviewsRequest = {}, options?: RawAxiosRequestConfig) {
        return ReviewStatsApiApiFp(this.configuration).reviewStatsApiGetAdminReviewStatsReviews(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.hasText, requestParameters.page, requestParameters.pageSize, requestParameters.ratingBand, requestParameters.search, requestParameters.sortOrder, requestParameters.source, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum = {
    Low: 'low',
    Mid: 'mid',
    High: 'high',
    Unrated: 'unrated',
} as const;
export type ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum = typeof ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum[keyof typeof ReviewStatsApiGetAdminReviewStatsReviewsRatingBandEnum];
export const ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum = typeof ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum[keyof typeof ReviewStatsApiGetAdminReviewStatsReviewsSortOrderEnum];
export const ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum = {
    CourseReview: 'course_review',
    CourseFeedback: 'course_feedback',
    ExtensionRating: 'extension_rating',
    ExtensionUninstall: 'extension_uninstall',
    SupportFeedback: 'support_feedback',
} as const;
export type ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum = typeof ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum[keyof typeof ReviewStatsApiGetAdminReviewStatsReviewsSourceEnum];
